import SFXS from './audios'
import { useEffect } from 'react'

export default function useGlobalAudio(volume: string, sound: boolean) {
  useEffect(() => {
    Object.keys(SFXS).map(key => {
      SFXS[key].volume = volume
      SFXS[key].muted = !sound
    })
  }, [sound, volume])

  return SFXS
}
